import { Navigate } from "react-router-dom";
import { useOperator } from "@/hooks";

export const Home = () => {
  const { id } = useOperator();
  return <Navigate to={`operator/${id}/bookings`} />;
};
